import React from "react";
import { Popconfirm } from "antd";
import { useFormContext } from "react-hook-form";
import { BookOpen } from "react-feather";
import PropTypes from "prop-types";
import { format } from "date-fns";

const SplitController = ({ addAttendanceHandler, id, isDisabled }) => {
  const { watch } = useFormContext();
  const splitHandler = (id) => {
    const attendance = watch("attendance");
    const index = attendance.findIndex((a) => a.id === id);
    if (index === -1) return;

    const existingSplits = attendance.filter(
      (a) =>
        a.id !== id &&
        a.attendanceDate === attendance[index].attendanceDate &&
        a.locationCode === attendance[index].locationCode &&
        a.employeeCode === attendance[index].employeeCode &&
        a.haveSplit
    );

    attendance[index].haveSplit = true;
    attendance[index].attendanceValue = Number(
      attendance[index].attendanceValue
    );

    const selectedTimeLog = attendance[index];
    selectedTimeLog.slno = selectedTimeLog.slno ?? 0;
    selectedTimeLog.haveShift = selectedTimeLog.shiftName !== "" ? true : false;
    selectedTimeLog.normalHours = selectedTimeLog.normalWorkingHours ?? 0;
    const clonedTimeLog = {
      ...selectedTimeLog,
      slno: 0,
      inTime: selectedTimeLog.outTime ?? "00:00:00",
      outTime: null, //"00:00:00",
      oT1: 0,
      oT2: 0,
      totalWorkingHours: 0,
      scheduleId: 0,
      shiftId: selectedTimeLog?.defaultShift.toString() ?? "",
      locationCode: selectedTimeLog.locationCode,
      projectCode: "",
      projectName: "",
      remarks: "",
      waitingTime: "00:00:00",
      wtrot: "00:00:00",
      isApproved: false,
      extraCharge: 0,
      attendanceValue: Number(selectedTimeLog.attendanceValue),
      haveSplit: true,
      hasOutTime: false,
      mode: "MM",
      wtnhEdit: true,
      haveShift: false,
      normalHours: 0,
    };
    const attendanceArray = [selectedTimeLog];
    if (existingSplits.length > 0) {
      existingSplits.map((s) => {
        s.slno = s.slno ?? 0;
        s.attendanceValue = Number(s.attendanceValue) || 0;
        s.haveShift = s.shiftName !== "" ? true : false;
        s.normalHours = s.normalWorkingHours ?? 0;
        attendanceArray.push(s);
      });

      //   existingSplit.attendanceValue =
      //     Number(existingSplit.attendanceValue) || 0;
      //   existingSplit.haveShift = existingSplit.shiftName !== "" ? true : false;
      //   existingSplit.normalHours = existingSplit.normalWorkingHours ?? 0;
      //   attendanceArray.push(existingSplit);
    }

    attendanceArray.sort((a, b) => a.slno - b.slno);
    attendanceArray.push(clonedTimeLog);

    const requestData = {
      companyCode: selectedTimeLog?.companyCode,
      attendanceDate: selectedTimeLog?.attendanceDate,
      locationCode: selectedTimeLog?.locationCode,
      fromDate:
        watch("attendanceFilterData.fromDate") ||
        format(new Date(), "yyyy-MM-dd"),
      toDate:
        watch("attendanceFilterData.toDate") ||
        format(new Date(), "yyyy-MM-dd"),
      attendance: attendanceArray,
    };

    addAttendanceHandler({ payload: requestData, id: "" });
  };

  return (
    <Popconfirm
      title="Split the row?"
      description="Really want new row for this date ?"
      icon={<BookOpen className="me-2" />}
      // onConfirm={() => }
      onConfirm={() => splitHandler(id)}
      onCancel={() => console.log("Cancel")}
      okText="Yes"
      cancelText="No"
    >
      <button
        type="button"
        className="btn btn-secondary btn-sm"
        disabled={isDisabled}
      >
        <BookOpen size={16} />
      </button>
    </Popconfirm>
  );
};

export default React.memo(SplitController);

SplitController.propTypes = {
  addAttendanceHandler: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};
